app.controller('supportController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $controller) {
    
  //Include custom controller functionality
	$controller('userDefinedSupportController', {$scope: $scope, $stateParams: $stateParams});
  
	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}

	$scope.openPopUp = function()
	{
		if($('#loginMessage .report-login-message').length > 0)
		{
			$('#loginMessage').modal({
	            backdrop: 'static',
	            keyboard: true, 
	            show: true
	        });
		}
	}
	
	
    $scope.listToggle = function(id)
    {
        if($('#' + id + ' label i').hasClass('fa fa-chevron-down'))
        {
            $('#' + id + ' label i').removeClass('fa fa-chevron-down');
            $('#' + id + ' label i').addClass('fa fa-chevron-right');
        }
        else if($('#' + id + ' label i').hasClass('fa fa-chevron-right'))
        {
            $('#' + id + ' label i').removeClass('fa fa-chevron-right');
            $('#' + id + ' label i').addClass('fa fa-chevron-down');            
        }
    };
    
});
